import React, { useEffect, useState } from "react";
import { Layout, Typography, Spin, Row, Col } from "antd";
import useRequest from "../../hooks/useRequest";
import apiPath from "../../constants/apiPath";
import lang from "../../helper/langHelper";
import './PrivacyPolicy.css';

const { Content } = Layout;
const { Title } = Typography;

const TnC = () => {
    const { request } = useRequest();
    const [description, setDescription] = useState();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        request({
            url: apiPath.common.content + "/terms-and-conditions",
            method: "GET",
            onSuccess: (data) => {
                if (data.status) {
                    if (data.data?.is_active) {
                        setDescription(data.data?.description);
                    } else {
                        setDescription("No Content Found!");
                    }
                } else {
                    setDescription("Something Went Wrong!!");
                }
                setLoading(false);
            },
            onError: (err) => {
                console.log(err);
                setDescription("Something Went Wrong!!");
                setLoading(false);
            }
        })
    }, []);

    return (
        <Layout>
            <Content className="privacy-policy-content">
                <div style={{ border: "2px solid black" }} className="contentWrapper">
                    <Row justify="center">
                        <Col xs={24} md={18}>
                            <div style={{ marginTop: "50px" }} className="sectionHeading">
                                <Title>{lang("Terms & Condition")} {lang("of")} Dunnnit</Title>
                                <div className="titleDesign"></div>
                            </div>
                            <div className="aboutOuter">
                                {loading ? (
                                    <Spin size="large" />
                                ) : (
                                    <div className="description" dangerouslySetInnerHTML={{ __html: description }}>
                                    </div>

                                    // <Paragraph className="description" dangerouslySetInnerHTML={{ __html: description }} />
                                )}
                            </div>
                        </Col>
                    </Row>
                </div>
            </Content>
        </Layout>
    );
}

export default TnC;
